export default __webpack_public_path__ + "tmp_src/components/ManualSwitcherTrigger/ManualSwitcherTrigger.css.liquid";